import { render, staticRenderFns } from "./AccountCard.vue?vue&type=template&id=5451acf7&scoped=true"
import script from "./AccountCard.vue?vue&type=script&lang=js"
export * from "./AccountCard.vue?vue&type=script&lang=js"
import style0 from "./AccountCard.vue?vue&type=style&index=0&id=5451acf7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5451acf7",
  null
  
)

export default component.exports